import script from "./lyarea.vue?vue&type=script&setup=true&lang=js"
export * from "./lyarea.vue?vue&type=script&setup=true&lang=js"

import "./lyarea.vue?vue&type=style&index=0&id=6ab3b39e&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab3b39e"]])

export default __exports__